export const FORECAST = "forecast";
export const PLANNER = "planner";
